import { atom } from "recoil";

export const addStateCodeLevel = atom({
  key: "addStateCodeLevel ",
  default: false,
});
export const editStateCodeLevel = atom({
  key: "editStateCodeLevel",
  default: false,
});
export const selectedCodeLevel = atom({
  key: "selectedCodeLevel",
  default: [],
});

export const selectedRowsStateCodeLevel = atom({
  key: "selectedRowsStateCodeLevel",
  default: [],
});

export const setFilterTextCodeLevel = atom({
  key: "setFilterTextCodeLevel",
  default: "",
});
